import { Search } from "lucide-react";
import { Button } from "@/components/ui/Button";
import type { LeaveProxyTarget } from "../types";

/** Searchable employee list for the "file on behalf" pickers on the review pages. */
export function EmployeePickerContent({
  targets,
  search,
  onSearchChange,
  onSelect,
  onCancel,
}: {
  targets: LeaveProxyTarget[];
  search: string;
  onSearchChange: (v: string) => void;
  onSelect: (t: LeaveProxyTarget) => void;
  onCancel: () => void;
}) {
  const q = search.toLowerCase();
  const filtered = q ? targets.filter((t) => t.full_name.toLowerCase().includes(q)) : targets;
  return (
    <div className="flex flex-col gap-3">
      <div className="relative">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
        <input
          autoFocus
          type="text"
          className="w-full pl-8 pr-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-[var(--color-primary)]"
          placeholder="Szukaj po nazwisku..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <ul className="divide-y divide-gray-100 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-md overflow-hidden max-h-80 overflow-y-auto">
        {filtered.length === 0 ? (
          <li className="px-4 py-3 text-sm text-gray-400 dark:text-gray-500 text-center">Brak wyników.</li>
        ) : (
          filtered.map((t) => (
            <li key={t.id}>
              <button
                className="w-full text-left px-4 py-2.5 text-sm text-gray-800 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                onClick={() => onSelect(t)}
              >
                {t.full_name}
                {!t.is_active && (
                  <span className="ml-2 text-xs text-amber-600 dark:text-amber-400">(nieaktywny)</span>
                )}
              </button>
            </li>
          ))
        )}
      </ul>
      <div className="flex justify-end">
        <Button variant="secondary" onClick={onCancel}>Anuluj</Button>
      </div>
    </div>
  );
}
